import React, { Fragment } from 'react';
import { useStyles } from './background.style';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const Background = ({ children, middleItem, height, row, backgroundColor, add, overflow,display,position }: any) => {
	const classes = useStyles();
	const matches = useMediaQuery('(max-width:991px)');
	return (
		<Fragment>
			{row ? (
				matches ? (
					<section
						className="d-flex flex-row flex-wrap justify-content-start"
						style={{
							backgroundColor: matches ? '' : '#F1F6FA',
							height: height ? height : 'auto',
							top: add ? '' : '14rem',
						}}
					>
						<div className={`${classes.background} px-3 mx-auto d-flex align-items-center`}>{children}</div>
					</section>
				) : (
					<section
						className=" d-flex flex-row flex-wrap justify-content-start"
						style={{ backgroundColor: '#F1F6FA', height: height ? height : 'auto' }}
					>
						<div className={`${classes.sideNavBG}`}>
							<img src={middleItem} alt="" className={classes.positionLogo} />
						</div>

						<div className={`${classes.background} px-3 d-flex align-items-center`}>{children}</div>
					</section>
				)
			) : (
				<section style={{ background: backgroundColor, height: height ? height : 'auto'
				,overflow: overflow ? overflow : '',
				display:display ? display : '',
				position:position ? position : ''
				}}>
					<div className={`${classes.background} px-3 mx-auto`}>{children}</div>
				</section>
			)}
		</Fragment>
	);
};

export default Background;
